import React from "react";

import Table from "../../common/Table";

class UserList extends React.Component {
  render() {
    const data = [
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
      {
        FirstName: "aawdawdawdawdawdawlex",
        LastName: "kkddwdawdawdawdawdawdawdkkk",
        Email: "123211@123.com",
      },
    ];
    const columnsSet = [
      {
        data: "FirstName",
        title: "First Name",
        autowidth: false,
      },
      {
        data: "LastName",
        title: "Last Name",
        autowidth: false,
      },
      {
        data: "Email",
        title: "Email",
        autowidth: false,
      },
    ];

    return (
      <div>
        <h1 className="page-header">Manage Users</h1>
        <Table
          className="dataTable"
          columns={columnsSet}
          data={data}
          paging={true}
        />
      </div>
    );
  }
}

export default UserList;
